/**
 * Where a reader's page sits in the nav.
 *
 * A seeker reaches a reader's page from the Community gallery (or a shared
 * link that stands in for it). While they are on that page — the two-column
 * profile, before Get Reading takes the screen — the Community tab is lit and
 * an X in the corner returns them to the gallery.
 */
export function onReaderProfile ({ activePanel, readerLayout, sessionFocus }) {
  if (!readerLayout || sessionFocus) return false
  return activePanel === '' || activePanel === 'session'
}

export function communityTabActive (state) {
  return state.activePanel === 'community' || onReaderProfile(state)
}
